import { LAYERS, LAYERS_NAMES, registerNewProjection } from 'app/utils/maps/layer/layerUtils';
import { LAYER_SUB_TYPE_MAP } from 'app/config/layerZIndexConfig';
import { Tile as TileLayer } from 'ol/layer';
import XYZ from 'ol/source/XYZ';
import uuidv1 from 'uuid/v1';
import { render, compile } from 'app/utils/template/template';
import { get as getProjection } from 'ol/proj';

const _getTileLayerProjection = (projection) => {
    const defaultProjection = getProjection('EPSG:3857');
    try {
        return projection?.srid ? getProjection(`EPSG:${projection.srid}`) || defaultProjection : defaultProjection;
    } catch (error) {
        console.log('xyzLayerUtils _getTileLayerProjection ~ error:', error); // eslint-disable-line
    }
    return defaultProjection;
}

export const drawXYZLayer = (attributes) => {
    const { _attributes } = attributes;
    const { name, id, url, apiKey, projection, zIndex, baseLayer } = _attributes;
    
    if(projection?.srid) {
        registerNewProjection(projection) 
    }
    
    const subtitle = url ? new URL(url).hostname : '';
    const urlApiKey = render(compile(url), { apikey: apiKey });
    
    const _projection = _getTileLayerProjection(projection);

    const finalZIndex = baseLayer ? 1 : (zIndex ?? LAYER_SUB_TYPE_MAP.entity);

    const layerToAdd = new TileLayer({
        title: name || uuidv1(),
        opacity: _attributes?.opacity || 1,
        visible: _attributes?.visible,
        baseLayer: baseLayer,
        attributes: {
            id,
            type: LAYERS.xyz,
            iconName: 'view-grid',
            layerType: LAYERS_NAMES.xyz,
            subtitle,
        },
        source: new XYZ({
            projection: _projection,
            url: urlApiKey,
            crossOrigin: 'anonymous',
            
            imageLoadFunction: (imageTile, src) => {
                const image = imageTile.getImage();
                image.src = src;
                image.onerror = () => {
                    imageTile.setState(2); 
                };
            },
        }),
        zIndex: finalZIndex, 
    });

    return layerToAdd;
};